module.exports = __webpack_public_path__ + "static/media/foto_news.520e51c0.png";